<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>库存管理</el-breadcrumb-item>
      <el-breadcrumb-item>外部采购列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-button size="mini" plain @click="showPurchaseDialog"
               v-if="authorities.includes('storage.outpurchase.new')">新建采购单</el-button>
    <el-date-picker
      v-model="purchaseRequest.selectDate"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyy-MM-dd"
      size="mini"
      @change="queryPurchase"
    >
    </el-date-picker>
    <el-input v-model="purchaseRequest.name" placeholder="请输入内容" size="mini" style="width: 200px;"></el-input>
    <el-button size="mini" @click="queryPurchase">查询</el-button>
    <br>
    <span style="font-size: 13px;color: #3a8ee6">合计数量：{{totalNum}} 个</span>
    <span style="font-size: 13px;color: #3a8ee6">合计金额：{{totalMoney}} 元</span>
    <el-table height="550px" :data="outsideOrderList" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
              :row-style="{height: '0'}"
              :cell-style="orderStateColor">
      <el-table-column
        label="操作"
        fixed="fixed"
        align="center"
        width="60">
        <template slot-scope="scope" style="display: flex;align-items: center">
          <div style="display: flex;justify-content: space-evenly">
            <div v-if="authorities.includes('storage.outpurchase.cancel')">
              <el-link type="danger" v-if="scope.row.state === 2" :disabled="true"  icon="iconfont icon-zuofei"></el-link>
              <el-link type="danger" v-if="scope.row.state === 1"  icon="iconfont icon-zuofei" @click="cancelPurchase(scope.row)"></el-link>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="purchaseDate"
        label="采购日期"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        align="center"
        prop="state"
        :formatter="stateFormatter"
        width="70"
        label="状态" >
      </el-table-column>
      <el-table-column
        prop="consumptionName"
        label="采购产品"
        align="center"
        width="200"
        >
      </el-table-column>
      <el-table-column
        prop="num"
        label="采购数量"
        width="70"
        align="center">
      </el-table-column>
      <el-table-column
        prop="purchaseMoney"
        label="采购费用"
        align="center"
        v-if="orgLevel > 1">
      </el-table-column>
      <el-table-column
        prop="buyerName"
        label="采购人"
        width="100"
        align="center">
      </el-table-column>
      <el-table-column
        prop="purchaseNo"
        label="采购单号"
        align="center"
        width="200"
      >
      </el-table-column>
      <el-table-column
        prop="madeIn"
        label="产地"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="validDate"
        label="有效期"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        label="备注"
        align="center"
        width="200">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>{{ scope.row.comment }}</p>
            <div slot="reference" class="name-wrapper">
              <el-tag size="mini">{{ scope.row.comment }}</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 3px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>

    <!-- 创建采购单 -->
    <el-dialog
      title="外部采购单"
      :visible.sync="purchaseDialogVisible"
      :width="width"
      @close="closePurchaseDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div style="margin-top:5px;text-align: right">
        <el-button size="mini" plain @click="showProductDrawer">添加明细</el-button>
      </div>
      <el-table :data="selectProductList" fit border stripe="stripe" width="100%"
                :header-cell-style="{background:'#eff3f8', color:'#333'}"
                height="300"
                :row-style="{height: '0'}">
        <el-table-column
          align="center"
          prop="userName"
          label="操作" width="60">
          <template slot-scope="scope">
            <el-link type="danger" icon="el-icon-delete"
                     @click="deleteConsumptionShowList(scope.$index, selectProductList)"></el-link>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="consumptionName"
          label="产品名称" width="150">
        </el-table-column>
        <el-table-column
          align="center"
          label="数量" width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.num"  size="mini" @blur="getTotal"/>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="产地" width="150">
          <template slot-scope="scope">
            <el-input v-model="scope.row.madeIn"  size="mini"/>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="有效期" width="160">
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.validDate"
              type="date"
              size="mini"
              style="width: 130px;"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="备注" width="180">
          <template slot-scope="scope">
            <el-input v-model="scope.row.comment"  size="mini"/>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="采购单价" v-if="orgLevel > 1">
          <template slot-scope="scope">
            <el-input v-model="scope.row.oneLevelPrice"  size="mini" @blur="getTotal"/>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="小计" v-if="orgLevel > 1">
          <template slot-scope="scope">
            {{ (scope.row.oneLevelPrice * scope.row.num).toFixed(1)}}
          </template>
        </el-table-column>
      </el-table>

      <div style="height: 150px;margin-top: 10px;display: flex;justify-content: space-between" v-if="orgLevel > 1">
        <div>
          <span >采购金额： </span>
          <el-input style="width: 300px" v-model="purchase.purchaseMoney" size="mini"
                    onkeyup="value=value.replace(/[^\d.]/g,'')"/>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="closePurchaseDialog">取 消</el-button>
        <el-button size="mini" @click="createPurchase">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 选择产品 -->
    <el-drawer
      title="产品列表"
      size="50%"
      :visible.sync="productDrawerVisible"
      :before-close="closeProductDrawer"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-input size="mini"
                style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                placeholder="输入关键字进行过滤"
                v-model="queryProductText"
                @keyup.enter.native="queryConsumption"
      >
      </el-input>
      <el-table :data="productList" fit border stripe="stripe" width="100%"  size="mini"
                :header-cell-style="{background:'#eff3f8', color:'#333'}"
                style="height: 550px;">
        <el-table-column
          align="center"
          label="操作" width="180">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.num"
                             size="mini"
                             @change="orderNumHandleChange(scope.row)" :min="0" :max="1000000" label="描述文字"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="consumptionName"
          label="产品名称">
        </el-table-column>
        <el-table-column
          align="center"
          prop="oneLevelPrice">
        </el-table-column>
      </el-table>
      <div style="margin-top: 3px;">
        <el-pagination
          @size-change="handleSizeChange5"
          @current-change="handleCurrentChange5"
          :current-page="currentPage5"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize5"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal5">
        </el-pagination>
      </div>
    </el-drawer>

    <!-- 选择全部产品 -->
    <el-drawer
      title="产品列表"
      size="50%"
      :visible.sync="productAllDrawerVisible"
      :before-close="closeAllProductDrawer"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div class="between" style="padding: 0 10px">
        <div class="left_con" >
          <div class="left_inner_con">
            <el-input size="mini"
                      style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                      placeholder="输入关键字进行过滤"
                      v-model="consumptionTypeFilterText">
            </el-input>
            <el-tree
              :data="consumptionTypeList"
              :props="consumptionTypeProps"
              @node-click="consumptionTypeHandleNodeClick"
              :highlight-current="true"
              node-key="id"
              :filter-node-method="consumptionTypeFilterNode"
              default-expand-all
              ref="serviceTree"
            >
            </el-tree>
          </div>
        </div>
        <div class="table_container" style="margin: 10px 0">
          <el-input size="mini"
                    style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                    placeholder="输入关键字进行过滤"
                    v-model="consumptionQueryText"
                    @keyup.enter.native="queryConsumption1"
          >
          </el-input>
          <el-table height="550px" :data="consumptionList" fit border stripe="stripe"
                    :header-cell-style="{background:'#eff3f8', color:'#333'}"
                    :row-style="{height: '0'}">
            <el-table-column
              align="center"
              prop="userName"
              fixed="fixed"
              label="操作" width="180">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.num"
                                 size="mini"
                                 @change="orderNumHandleChange(scope.row)" :min="0" :max="1000000" label="描述文字"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="consumptionName">
            </el-table-column>
          </el-table>
          <div style="margin-top: 3px;">
            <el-pagination
              @size-change="handleSizeChange2"
              @current-change="handleCurrentChange2"
              :current-page="currentPage2"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="pageSize2"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageTotal2">
            </el-pagination>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data(){
    return{
      totalMoney:'',
      totalNum:'',
      orgLevel:'',
      currentOrgId:'',
      userId:'',
      authorities:'',
      outsideOrderList:[],
      queryText:'',
      purchaseDialogVisible:false,
      consumptionTypeFilterText:'',
      consumptionTypeList:[],
      consumptionTypeProps:{
        label: 'consumptionTypeName',
        children: 'children'
      },
      purchase:{
        id:'',
        purchaseDate:'',
        productNo:'',
        purchaseNo:'',
        purchaseMoney:'',
        buyer:'',
        orgId:'',
        orgLevel:'',
        orgName:'',
        creator:'',
        buyerName:'',
        consumptions:[],
        insidePurchaseDetails:[],
        selectDate:''
      },
      consumptionList:[],
      consumptionQueryText:'',
      productDialogVisible:false,
      productList:[],
      consumptionShowList:[],
      multipleSelection:[],

      productTypeFilterText:'',
      selectProductList:[],
      productDrawerVisible:false,
      productAllDrawerVisible:false,
      stateText:[
        {state:1, name:'正常'},
        {state:2, name:'已作废'}
      ],
      purchaseDetailDialogVisible:false,

      currentPage: 1,
      pageSize:20,
      pageTotal:0,

      currentPage5: 1,
      pageSize5:20,
      pageTotal5:0,

      currentPage2: 1,
      pageSize2:20,
      pageTotal2:0,

      consumptionTypeId:'',
      type:'',
      queryProductText:'',
      width:'60%',
      purchaseRequest:{
        selectDate:'',
        orgId:'',
        pageNum:'',
        pageSize:'',
        startDate:'',
        endDate:'',
        name:''
      },
      createPurchaseDoubleClick:false,
    }
  },
  methods:{
    queryPurchase(){
      this.loadOutPurchaseCount();
      this.loadOutPurchaseList();
    },
    async loadOutPurchaseCount(){
      this.totalMoney = '';
      this.totalNum = '';
      this.purchaseRequest.startDate = '';
      this.purchaseRequest.endDate = '';
      if (this.purchaseRequest.selectDate !== null){
        this.purchaseRequest.startDate = this.purchaseRequest.selectDate[0];
        this.purchaseRequest.endDate = this.purchaseRequest.selectDate[1];
      }
      this.purchaseRequest.pageNum = this.currentPage;
      this.purchaseRequest.pageSize = this.pageSize;
      this.purchaseRequest.orgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`/count/outPurchase`, this.purchaseRequest)
      this.pageTotal = res.totalPage;
    },
    async loadOutPurchaseList(){
      this.totalMoney = '';
      this.totalNum = '';
      this.purchaseRequest.startDate = '';
      this.purchaseRequest.endDate = '';
      if (this.purchaseRequest.selectDate !== null){
        this.purchaseRequest.startDate = this.purchaseRequest.selectDate[0];
        this.purchaseRequest.endDate = this.purchaseRequest.selectDate[1];
      }
      this.purchaseRequest.pageNum = this.currentPage;
      this.purchaseRequest.pageSize = this.pageSize;
      this.purchaseRequest.orgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`/outPurchase/query`, this.purchaseRequest)
      this.outsideOrderList = res.data;
      const {data:res1} = await this.$http.post(`/outPurchase/query/total`, this.purchaseRequest)
      if (res1.data !== null){
        this.totalNum = res1.data.totalNum;
        this.totalMoney = res1.data.totalMoney;
      }
    },

    showPurchaseDialog(){
      if (this.orgLevel == 1){
        this.width = "60%";
      }
      this.purchase.productNo = '';
      this.purchase.purchaseMoney= '';
      this.selectProductList = [];
      this.purchaseDialogVisible = true;
    },
    closePurchaseDialog(){
      this.purchaseDialogVisible = false;
    },
    showProductDialog(){
      this.productDialogVisible = true;
    },
    productDialogClose(){
      this.productDialogVisible = false;
    },
    deleteConsumptionShowList(index,rows){
      rows.splice(index, 1);
      this.getTotal();
    },
    //选中产品分类加载产品的方法
    consumptionTypeHandleNodeClick(data){
      this.consumptionTypeId = data.consumptionTypeId;
      this.type = data.type;
      this.loadProductByProductType();
    },
    async loadProductByProductType(){
      let text = 'null';
      if (this.consumptionQueryText !== ''){
        text = this.consumptionQueryText;
      }
      if ((this.orgLevel - 0) === 1){
        const {data:res} = await this.$http.get(`/consumption/typeId/${this.consumptionTypeId}/orgId/${this.currentOrgId}/queryConsumption/${text}/pageNum/${this.currentPage2}/pageSize/${this.pageSize2}`)
        this.consumptionList = res.data.list;
        this.pageTotal2 = res.data.total;
      } else {
        const {data:res} = await this.$http.get(`/consumption/type/${this.type}/typeId/${this.consumptionTypeId}/orgId/${this.currentOrgId}/queryConsumption/${text}/pageNum/${this.currentPage2}/pageSize/${this.pageSize2}`)
        this.consumptionList = res.data.list;
        this.pageTotal2 = res.data.total;
      }
    },
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.loadProductByProductType();
    },
    handleCurrentChange2(val) {
      this.currentPage2 = val;
      this.loadProductByProductType();
    },
    //关键字查询产品的方法
    queryConsumption1(){
      this.loadProductByProductType();
    },

    consumptionTypeFilterNode(value, data) {
      if (!value) return true;
      return data.consumptionTypeName.indexOf(value) !== -1;
    },
    //关键字查询产品的方法
    queryConsumption(){
      this.loadProductList();
    },
    async createPurchase(){
      this.purchase.buyer = this.userId;
      this.purchase.orgId = this.currentOrgId;
      this.purchase.consumptions = this.selectProductList;
      this.purchase.orgLevel = this.orgLevel;
      if (this.selectProductList.length === 0){
        return this.$message.warning("请选择采购产品！");
      }
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/outsidePurchase`, this.purchase);
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      await this.queryPurchase();
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      this.closePurchaseDialog();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    orderNumHandleChange(value){
      let result = true;
      for (let i = 0; i < this.selectProductList.length; i++) {
        if (this.selectProductList[i].id === value.id && value.num > 0){
          this.selectProductList[i].num = value.num;
          result = false;
        }
        if (this.selectProductList[i].id === value.id && value.num === 0){
          this.selectProductList.splice(i,1);
          result = false;
        }
      }
      if (result){
        this.selectProductList.push(value);
      }
    },
    showProductDrawer(){
      if ((this.orgLevel - 0) === 1){
        this.loadProductTypeList();
        this.productAllDrawerVisible = true;
      } else {
        this.loadProductList();
        this.productDrawerVisible = true;
      }
    },
    //记载产品分类的方法
    async loadProductTypeList(){
      this.consumptionList = [];
      const {data:res} = await this.$http.get(`/consumptionType/purchase/orgId/${this.currentOrgId}`)
      this.consumptionTypeList = res.data;
    },
    closeAllProductDrawer(){
      this.getTotal();
      this.productAllDrawerVisible = false;
    },
    closeProductDrawer(){
      let purchaseMoney = 0;
      for (let i = 0; i < this.selectProductList.length; i++) {
        purchaseMoney += this.selectProductList[i].oneLevelPrice * this.selectProductList[i].num;
      }
      this.purchase.purchaseMoney = purchaseMoney;
      this.productDrawerVisible = false;
    },
    async loadProductList(){
      let text = 'null';
      if (this.queryProductText !== ''){
        text = this.queryProductText;
      }
      const {data:res} = await this.$http.get(`/consumption/purchase/orgId/${this.currentOrgId}/queryConsumption/${text}/pageNum/${this.currentPage5}/pageSize/${this.pageSize5}`)
      this.productList = res.data.list;
      this.pageTotal5 = res.data.total;
    },
    handleSizeChange5(val) {
      this.pageSize5 = val;
      console.log(`每页 ${val} 条`);
      this.loadProductList();
    },
    handleCurrentChange5(val) {
      this.currentPage5 = val;
      console.log(`当前页: ${val}`);
      this.loadProductList();
    },

    async loadPurchaseList(){
      const {data:res} = await this.$http.get(`/outsidePurchase/orgId/${this.currentOrgId}/pageNum/${this.currentPage}/pageSize/${this.pageSize}`)
      this.outsideOrderList = res.data.list;
      this.pageTotal = res.data.total;
    },
    stateFormatter(row){
      let value = "";
      for (let i = 0; i < this.stateText.length; i++){
        let item = this.stateText[i];
        if (row.state === item.state) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    orderStateColor({row,columnIndex}){
      if (row.state === 1 && columnIndex ===2){
        return 'color:#0CB618';
      } else if (row.state === 2 && columnIndex ===2){
        return 'color:#EA1B28';
      }
    },
    async cancelPurchase(row){
      const {data:res} = await this.$http.post(`/outsidePurchase/cancel`, row);
      // this.outsideOrderList = res.data;
      if (res.code === 200){
        this.$message.success("操作成功！");
        await this.queryPurchase();
      }

    },
    closePurchaseDetailDialog(){
      this.purchaseDetailDialogVisible = false;
    },
    showPurchaseDetailDialog(row){
      this.purchaseDetail(row);
      this.purchaseDetailDialogVisible = true;
    },
    async purchaseDetail(row){
      const {data:res} = await this.$http.get(`/outsidePurchase/id/${row.id}`);
      this.purchase = res.data;
    },
    getTotal(){
      let purchaseMoney = 0;
      for (let i = 0; i < this.selectProductList.length; i++) {
        purchaseMoney += this.selectProductList[i].oneLevelPrice * this.selectProductList[i].num;
      }
      this.purchase.purchaseMoney = purchaseMoney;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      console.log(`每页 ${val} 条`);
      this.loadPurchaseList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(`当前页: ${val}`);
      this.loadPurchaseList();
    }
  },
  watch: {
    consumptionTypeFilterText(val) {
      this.$refs.serviceTree.filter(val);
    }
  },
  created() {
    this.currentOrgId = window.sessionStorage.getItem('currentOrgId');
    this.orgLevel = window.sessionStorage.getItem('orgLevel');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.queryPurchase();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 90vh;
}

.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: auto;
  //border: 1px solid;
  margin: 10px 0;
  //width: 100px;
}
.left_inner_con{
  width: 300px;
  height: 90vh;
  overflow-y: auto;
  margin-right: 10px;
  //background-color: #F2F6FC;
}

.box-card{
  margin: 10px 10px 10px 10px;
  height: 86%;
}
.spanLabel{
  color: #848484;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}
.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
.table_container{
  flex: 1;
  width: 800px;
  height: 100%;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OutPurchase.vue